// Centrální konfigurace webu.
// Cenu, limity, checkout URL i analytické identifikátory měň POUZE zde.

export const SITE = {
  brand: "Proměna muže",
  author: "Lukáš Havel",
  siteUrl: "https://promenamuze.cz",
  bookTitle: "40 principů lepšího muže",
  bookSubtitle: "Praktický průvodce osobním rozvojem, sebevědomím a vztahy",

  introPrice: 159,
  futurePrice: 299,
  introLimit: 100,
  // TODO: Až bude dostupný počet objednávek ze SimpleShop API, lze zde
  // automaticky přepnout cenu/text po prvních 100 prodejích.

  checkoutUrl: "https://form.simpleshop.cz/ODB6g/buy/",

  contactEmail: "info@promenamuze.cz",

  // Zákonné identifikační údaje provozovatele – pouze pro právní stránky
  // (/kontakt, /obchodni-podminky). Na hlavní landing page neuvádět.
  operator: {
    name: "Lukáš Havel",
    ico: "87771322",
    address: "Občinská 4405, 580 01 Havlíčkův Brod",
  },

  analytics: {
    ga4Id: "", // TODO: doplnit GA4 Measurement ID (G-XXXXXXX)
    gtmId: "", // TODO: doplnit GTM ID (GTM-XXXXXXX)
    metaPixelId: "", // TODO: doplnit Meta Pixel ID
  },
};

export const priceCta = `Chci e-book za ${SITE.introPrice} Kč`;
